<form [formGroup]="shippingTypeForm">
  <div class="field mb-4">
    <!-- Start::title -->
    <span class="text-900 text-2xl block font-semibold mb-5"
      >¿Cómo quieres recibir tu pedido?</span
    >
    <!-- End::title -->

    <!-- Start::description box -->
    <p
      class="font-semibold underline mb-4 cursor-pointer"
      (click)="isVisibleSidebar = true"
    >
      Información de los servicios disponibles
    </p>
    <!-- End::description box -->

    <!-- Start::description sidebar -->
    <p-sidebar
      [(visible)]="isVisibleSidebar"
      position="right"
      styleClass="w-screen lg:w-4"
    >
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <span class="font-bold text-lg"> Sobre nuestros servicios </span>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <p-accordion styleClass="mt-4" [activeIndex]="0">
          <p-accordionTab header="Entrega a domicilio">
            <p>{{ deliveryText }}</p>
          </p-accordionTab>
          <p-accordionTab header="Retiro en tienda">
            <p>{{ pickupText }}</p>
          </p-accordionTab>
        </p-accordion>
      </ng-template>
    </p-sidebar>
    <!-- End::description sidebar -->

    <!-- Start::shipment type -->
    <div class="flex flex-column lg:flex-row field p-0 gap-3">
      @for(type of shippingTypes; track $index){
      <div
        class="flex p-3 gap-3 border-round border-1 surface-border w-full cursor-pointer flex align-items-center min-h-7rem md:min-h-6rem"
        [ngClass]="{
          'surface-border hover:border-400':
            shipmentTypeField?.value !== type.value,
          'border-primary bg-blue-50': shipmentTypeField?.value === type.value
        }"
        (click)="onSelectShipmentType(type.value)"
      >
        <p-radioButton
          name="shipmentType"
          [value]="type.value"
          formControlName="shipmentType"
        />
        <div>
          <div class="font-semibold mb-1">{{ type.title }}</div>
          <span class="text-sm">{{ type.description }}</span>
        </div>
        <i
          class="fa-sharp-duotone fa-solid text-4xl ml-auto"
          [ngClass]="[
            type.icon,
            shipmentTypeField?.value === type.value ? 'text-blue-500' : ''
          ]"
        ></i>
      </div>
      }
    </div>
    <!-- End::shipment type -->
  </div>
</form>
